const formats = [
  {
    icon: 'ri-chat-3-line',
    title: 'Интервью',
    desc: 'Структурированные интервью с сотрудниками и руководителями для понимания опыта, подходов и поведения.',
  },
  {
    icon: 'ri-user-search-line',
    title: 'Ассессмент',
    desc: 'Практическая оценка поведения и компетенций через упражнения и моделирование рабочих ситуаций.',
  },
  {
    icon: 'ri-surround-sound-line',
    title: '360 градусов',
    desc: 'Сбор обратной связи от руководителя, коллег и других участников взаимодействия.',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Тестирование',
    desc: 'Использование тестовых инструментов там, где они действительно помогают ответить на задачу оценки.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Практические задания',
    desc: 'Оценка способности применять компетенции в ситуациях, близких к реальной работе.',
  },
  {
    icon: 'ri-bar-chart-line',
    title: 'Анализ рабочих результатов',
    desc: 'Использование объективных показателей работы как одного из источников информации.',
  },
  {
    icon: 'ri-stack-line',
    title: 'Комплексная оценка',
    desc: 'Комбинация нескольких методов для получения более полной и достоверной картины.',
  },
];

export default function AssessmentFormats() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Форматы оценки
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Не существует одного метода, который всегда лучше другого. Выбор определяется задачей оценки, ролью сотрудника и глубиной необходимых выводов.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {formats.map((f, i) => (
            <div key={i} className="bg-gray-50 rounded-xl border border-gray-100 p-5 md:p-6 hover:border-teal-200 transition-colors group">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-200 transition-colors">
                <i className={`${f.icon} text-xl text-teal-700`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{f.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>

        <p className="text-center text-sm md:text-base text-gray-500 mt-8 max-w-3xl mx-auto leading-relaxed">
          При необходимости методы комбинируются, чтобы не делать выводы на основании одного показателя.
        </p>
      </div>
    </section>
  );
}